module.exports = __webpack_public_path__ + "static/media/inbox-out.8668648b.svg";